import SearchFeed from "components/Feed/SearchFeed";
import Tabs from "components/Feed/Tabs";
import { useEffect, useRef, useState } from "react";
import UploadMedia from "components/Feed/UploadMedia";
import { useFeed } from "contexts/FeedContext";
import Coins from "components/Feed/Coins";
import { toast } from 'react-toastify';

function FeedPage() {
    const [isLogin, setIsLogin] = useState(false);
    const { feeds, filters, setFilters, categories, riskTypes, locationTree, setPage, hasMore } = useFeed();
    const loaderRef = useRef<HTMLDivElement | null>(null);
    const isFirstIntersect = useRef(true);
    const loadingRef = useRef(false);

    useEffect(() => {
        setIsLogin(!!localStorage.getItem("email"));
    }, []);

    // Observe loader for infinite scroll
    useEffect(() => {
        if (!hasMore || !loaderRef.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !loadingRef.current) {
                    loadingRef.current = true; // 👈 prevent multiple triggers
                    if (isFirstIntersect.current) {
                        isFirstIntersect.current = false;
                    } else {
                        setPage(prev => prev + 1);
                    }
                }
            },
            { threshold: 1 }
        );

        observer.observe(loaderRef.current);

        return () => observer.disconnect();
    }, [hasMore, setPage]);

    useEffect(() => {
        loadingRef.current = false;
    }, [feeds]);

    return (
        <>
            <SearchFeed
                filters={filters}
                setFilters={setFilters}
                categories={categories}
                riskTypes={riskTypes}
                locationTree={locationTree}
            />
            
            { isLogin && 
                <section>
                    <div className="container grid grid-cols-1 md:grid-cols-2 items-center mb-3">
                        <UploadMedia />
                        <Coins />
                    </div>
                </section>}

            <section>
                {feeds.length === 0 ? (
                    <div className="text-center py-10 text-lg text-primaryColor font-medium">
                        No media items found.
                    </div>
                ) : (
                    <Tabs feeds={feeds} filters={filters} />
                )}
            </section>

            {hasMore && <div ref={loaderRef} className="h-10" />}
        </>
    );
}

export default FeedPage;